import { lazyPage, type ModulePlugin } from "@keel/core";
import { AskAboutParty, AssistantButton } from "./Assistant";
import { AssistantSettingsTab } from "./Settings";

const AssistantPage = lazyPage(() => import("./Assistant"), "AssistantPage");

/** The assistant (optional module, ERP-129): ask about the system or your data, have it do things. */
const plugin: ModulePlugin = {
  key: "assistant",
  help: () => import("./help"),
  nav: [
    {
      group: "Platform",
      items: [{ to: "/assistant", label: "Assistant", icon: "sparkle", perm: "assistant.chat.write" }],
    },
  ],
  routes: [{ path: "/assistant", element: <AssistantPage /> }],
  commands: [["Ask the assistant", "/assistant", "sparkle", "assistant.chat.write"]],
  settingsTabs: [
    {
      key: "assistant",
      label: "Assistant",
      perm: "assistant.settings.manage",
      element: <AssistantSettingsTab />,
    },
  ],
  partyActions: [{ key: "assistant", perm: "assistant.chat.write", component: AskAboutParty }],
  topbar: [{ key: "assistant", perm: "assistant.chat.write", component: AssistantButton }],
};
export default plugin;
